/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_OpenInputs */

const en_ui_open = /** @type {(inputs: Ui_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

/** @type {(inputs: Ui_OpenInputs) => LocalizedString} */
const ar_ui_open = en_ui_open;

/** @type {(inputs: Ui_OpenInputs) => LocalizedString} */
const he_ui_open = en_ui_open;

/** @type {(inputs: Ui_OpenInputs) => LocalizedString} */
const ur_ui_open = en_ui_open;

/** @type {(inputs: Ui_OpenInputs) => LocalizedString} */
const es_ui_open = en_ui_open;

/** @type {(inputs: Ui_OpenInputs) => LocalizedString} */
const fr_ui_open = en_ui_open;

/** @type {(inputs: Ui_OpenInputs) => LocalizedString} */
const de_ui_open = en_ui_open;

/** @type {(inputs: Ui_OpenInputs) => LocalizedString} */
const pt_ui_open = en_ui_open;

/** @type {(inputs: Ui_OpenInputs) => LocalizedString} */
const hi_ui_open = en_ui_open;

/** @type {(inputs: Ui_OpenInputs) => LocalizedString} */
const bn_ui_open = en_ui_open;

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Ui_OpenInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_open = /** @type {((inputs?: Ui_OpenInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_OpenInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_open(inputs)
	if (locale === "he") return he_ui_open(inputs)
	if (locale === "ur") return ur_ui_open(inputs)
	if (locale === "es") return es_ui_open(inputs)
	if (locale === "fr") return fr_ui_open(inputs)
	if (locale === "de") return de_ui_open(inputs)
	if (locale === "pt") return pt_ui_open(inputs)
	if (locale === "hi") return hi_ui_open(inputs)
	if (locale === "bn") return bn_ui_open(inputs)
	return /** @type {LocalizedString} */ ("Open")
});